import imageCompression from 'browser-image-compression';

export const stripHtmlTags = (html) => {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
};

export const fakeResponse = (data, delay = 2000) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(data);
        }, delay);
    });
};

export const firstLetterUppercase = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const truncateText = (text, maxLength = 300) => {
    if (!text) return '';
    return text.substring(0, maxLength);
};

export async function compressFile(file) {
    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true
    };
    const compressedFile = await imageCompression(file, options);
    return compressedFile;
}

export const handleCopyToClipboard = (text, timerRef, onSuccess) => {
    navigator.clipboard.writeText(text).then(() => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        onSuccess(true);
        timerRef.current = setTimeout(() => {
            onSuccess(false);
            timerRef.current = null;
        }, 2000);
    });
};

export const downloadCSV = (data, filename) => {
    const csvContent = [
        Object.keys(data[0]).join(','),
        ...data.map(row => Object.values(row).map(v => `"${v}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const generateCSVExport = (product, platform = 'shopify') => {
    const sanitized = {
        title: product.title,
        slug: product.slug,
        description: sanitizeCSVField(product.descriptionHtml),
        metaDescription: product.metaDescription,
        shortDescription: product.shortDescription
    };

    const formats = {
        shopify: [{
            Title: sanitized.title,
            'URL handle': sanitized.slug,
            Description: sanitized.description,
            Status: 'draft',
            'SEO title': sanitized.title,
            'SEO description': sanitized.metaDescription,
            "Option1 name": "Title",
            "Option1 value": "Default Title"
        }],
        woocommerce: [{
            Name: sanitized.title,
            Description: sanitized.description,
            'Short description': sanitized.shortDescription,
            Published: '-1',
            'Meta: _yoast_wpseo_title': sanitized.title,
            'Meta: _yoast_wpseo_metadesc': sanitized.metaDescription,
            'Meta: rank_math_title': sanitized.title,
            'Meta: rank_math_description': sanitized.metaDescription
        }]
    };

    return formats[platform] || formats.shopify;
};

const sanitizeCSVField = (text) => {
    if (!text) return "";
    return String(text).replace(/"/g, "'");
};